import clsx from "clsx";

type Props = {
  className?: string;
  children?: React.ReactNode;
  zIndex?: "small" | "middle" | "high";
};

export default function BottomGroup({
  children,
  className,
  zIndex = "small",
}: Props) {
  return (
    <div
      className={clsx([
        { fixed: true },
        "bottom-0 left-0 right-0 h-bottom-button bg-white",
        {
          "z-40": zIndex === "small",
          "z-50": zIndex === "middle",
          "z-70": zIndex === "high",
        },
        className,
      ])}
    >
      {children}
    </div>
  );
}
